module.exports = __webpack_public_path__ + "assets/img/6d94-ua.svg";